type GtagFunction = (...args: any[]) => void;

const deniedConsentState = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'granted',
  personalization_storage: 'denied',
  security_storage: 'granted',
} as const;

const grantedConsentState = {
  ad_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
  analytics_storage: 'granted',
  functionality_storage: 'granted',
  personalization_storage: 'granted',
  security_storage: 'granted',
} as const;

export const ensureGtag = (): GtagFunction | undefined => {
  if (typeof window === 'undefined') return undefined;
  const win = window as any;
  win.dataLayer = win.dataLayer || [];
  win.gtag =
    win.gtag ||
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      win.dataLayer.push(arguments);
    };
  return win.gtag as GtagFunction;
};

export const applyDefaultConsent = () => {
  const gtag = ensureGtag();
  if (!gtag) return;
  gtag('consent', 'default', {
    ...deniedConsentState,
    wait_for_update: 500,
  });
};

export const applyConsentUpdate = (isGranted: boolean) => {
  const gtag = ensureGtag();
  if (!gtag) return;
  gtag('consent', 'update', isGranted ? { ...grantedConsentState } : { ...deniedConsentState });
};

export const trackGtmEvent = (event: string, params: Record<string, unknown>) => {
  const gtag = ensureGtag();
  if (!gtag) return false;
  gtag('event', event, params);
  return true;
};
